export const MAC_SETUP_TASK_KEYS = [
  'inputMethodInstalled',
  'inputSourceEnabled',
  'inputSourceSelected',
  'backgroundActivityEnabled',
  'accessibilityEnabled'
]

export const normalizeMacSetupStatus = value => {
  if (!value || typeof value !== 'object' || value.available !== true ||
      !value.tasks || typeof value.tasks !== 'object') {
    return null
  }

  const tasks = MAC_SETUP_TASK_KEYS.reduce((result, key) => {
    result[key] = value.tasks[key] === true
    return result
  }, {})

  return {
    available: true,
    canRevealApplication: value.canRevealApplication === true,
    tasks,
    complete: MAC_SETUP_TASK_KEYS.every(key => tasks[key])
  }
}

export const shouldShowMacSetup = status =>
  !status || status.available !== true || status.complete !== true

export const completedMacSetupTaskCount = status => {
  if (!status || !status.tasks) return 0
  return MAC_SETUP_TASK_KEYS.filter(key => status.tasks[key] === true).length
}

export const shouldShowMacSetupTaskAction = (complete, alwaysAvailable = false) =>
  complete !== true || alwaysAvailable === true
